import { render, staticRenderFns } from "./MultimediaImages.vue?vue&type=template&id=74824875&"
import script from "./MultimediaImages.vue?vue&type=script&lang=js&"
export * from "./MultimediaImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports